var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-cascader',{attrs:{"placeholder":_vm.placeholder,"value":_vm.defaultListData,"field-names":_vm.type === 'city' ?
      { label: 'areaName', value: 'areaId', children: 'children' } :
      { label: 'industryName', value: 'industryId', children: 'children' },"options":_vm.cascaderList,"change-on-select":"","show-search":{ filter: _vm.filter },"expand-trigger":"hover","getPopupContainer":_vm.getPopupContainer,"popupClassName":_vm.getPopupClassName},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }